import { API, Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'

/**
 * Bloque de COSTE Orange (lo que gastamos) de una campaña, SOLO visible para admin de
 * plataforma. El backend (billing-stats) vuelve a gatear con isStrictAdmin, así que un
 * no-admin recibe 403 y aquí no se muestra nada.
 */
const eur = (n) =>
  (Number(n) || 0).toLocaleString('es-ES', {
    style: 'currency',
    currency: 'EUR'
  })
const num = (n) => (Number(n) || 0).toLocaleString('es-ES')

const Tile = ({ label, value, color }) => (
  <div className="flex-1 min-w-[130px] rounded-xl bg-white border border-gray-200 px-4 py-3 shadow-sm">
    <div className="text-xs text-gray-500">{label}</div>
    <div className="text-lg font-bold" style={color ? { color } : undefined}>
      {value}
    </div>
  </div>
)

const AdminCampaignCost = ({ campaignId }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let active = true
    const load = async () => {
      setLoading(true)
      setError(false)
      try {
        const token = (await Auth.currentAuthenticatedUser()).signInUserSession
          .idToken.jwtToken
        const res = await API.get(
          'rcs-api',
          `/billing-stats?campaignId=${campaignId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        if (active) setData(res)
      } catch (err) {
        if (active) setError(true)
      }
      if (active) setLoading(false)
    }
    if (campaignId) load()
    return () => {
      active = false
    }
  }, [campaignId])

  if (loading || error || !data) return null

  const marginPct =
    data.retailRcs > 0
      ? `${((data.margin / data.retailRcs) * 100).toFixed(1)}%`
      : '—'

  return (
    <div className="mt-6 rounded-2xl bg-amber-50 border-2 border-amber-200 px-5 py-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm font-bold text-amber-800">
          Coste Orange (admin) · estimado
        </div>
        <div className="text-xs text-amber-700">
          Básico {eur(data.rates?.basico)} · Simple {eur(data.rates?.simple)} ·
          Conv {eur(data.rates?.conversacional)}/sesión
        </div>
      </div>
      <div className="flex flex-wrap gap-3">
        <Tile label="Sesiones" value={num(data.sessions)} />
        <Tile label="Simple" value={num(data.simple)} />
        <Tile label="Básico" value={num(data.basico)} />
        <Tile label="Coste Orange" value={eur(data.cost)} color="#b45309" />
        <Tile label="Retail cobrado" value={eur(data.retailRcs)} />
        <Tile
          label={`Margen (${marginPct})`}
          value={eur(data.margin)}
          color={data.margin >= 0 ? '#237804' : '#a8071a'}
        />
      </div>
    </div>
  )
}

export default AdminCampaignCost
